import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  del,
  formDataPatch,
  formDataPost,
  get,
  patch,
  post,
} from "helpers/api_helper";
import {
  ADD_BRANCH,
  BRANCH_LIST_BY_CITY,
  BRANCH_LIST_WITH_CITY,
  DELETE_BRANCH,
  GET_ALL_BRANCHES,
  GET_BRANCH_DETAILS,
  GET_BRANCHES_LIST,
  SYNC_LOCKS,
  UPDATE_BRANCH,
  UPDATE_BRANCH_STATUS,
} from "helpers/url_helper";

export const addBranch = createAsyncThunk(ADD_BRANCH, async (payload) => {
  const response = await formDataPost(ADD_BRANCH, payload);
  return response;
});

export const updateBranch = createAsyncThunk(UPDATE_BRANCH, async (payload) => {
  const response = await formDataPatch(UPDATE_BRANCH, payload);
  return response;
});

export const getAllBranches = createAsyncThunk(
  GET_ALL_BRANCHES,
  async (payload) => {
    const response = await post(GET_ALL_BRANCHES, payload);
    return response;
  }
);

export const getBranchDetails = createAsyncThunk(
  GET_BRANCH_DETAILS,
  async (payload) => {
    const response = await post(GET_BRANCH_DETAILS, payload);
    return response;
  }
);

export const deleteBranch = createAsyncThunk(DELETE_BRANCH, async (payload) => {
  const response = await del(DELETE_BRANCH, payload);
  return response;
});

export const updateBranchStatus = createAsyncThunk(
  UPDATE_BRANCH_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_BRANCH_STATUS, payload);
    return response;
  }
);

export const getBranchListByCity = createAsyncThunk(
  BRANCH_LIST_BY_CITY,
  async (payload) => {
    const response = await post(BRANCH_LIST_BY_CITY, payload);
    return response;
  }
);

export const getBranchListWithCity = createAsyncThunk(
  BRANCH_LIST_WITH_CITY,
  async () => {
    const response = await get(BRANCH_LIST_WITH_CITY);
    return response;
  }
);

export const getBranchList = createAsyncThunk(
  GET_BRANCHES_LIST,
  async () => {
    const response = await get(GET_BRANCHES_LIST);
    return response;
  }
);

export const syncLocks = createAsyncThunk(
  SYNC_LOCKS,
  async () => {
    const response = await get(SYNC_LOCKS);
    return response;
  }
);
